import React from "react";

export const ReportsStatus = ({ value, paratext, colorBox, color }) => {
  return (
    <React.Fragment>
      <div className="reports-small-text-value d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <div className={colorBox} style={{backgroundColor:color}}></div>
          <div className="f10-500">{paratext}</div>
        </div>
        <div className="f10-400">{value}</div>
      </div>
    </React.Fragment>
  );
};
